import { OrderStatus } from '@/types/api/order';

export function orderStatusLabel(status: OrderStatus): string {
  // prettier-ignore
  switch (status) {
    case OrderStatus.Confirmed: return "Beställd";
    case OrderStatus.Delivered: return "Levererad";
    case OrderStatus.Confirmed: return "Slutförd";
    default:                    return "Ökänd"
  }
}

export function orderStatusBadge(status: OrderStatus) {
  // prettier-ignore
  switch (status) {
    case OrderStatus.Confirmed: return "bg-green-500/20 text-green-700";
    case OrderStatus.Delivered: return "bg-violet-500/20 text-violet-700";
    case OrderStatus.Confirmed: return "bg-green-700/20 text-green-900";
    default:                    return "bg-gray-500/20 text-gray-700"
  }
}
